import { render, staticRenderFns } from "./organization_shippings.vue?vue&type=template&id=88e62c90&scoped=true&"
import script from "./organization_shippings.vue?vue&type=script&lang=js&"
export * from "./organization_shippings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e62c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88e62c90')) {
      api.createRecord('88e62c90', component.options)
    } else {
      api.reload('88e62c90', component.options)
    }
    module.hot.accept("./organization_shippings.vue?vue&type=template&id=88e62c90&scoped=true&", function () {
      api.rerender('88e62c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/tabs/organization_shippings.vue"
export default component.exports